// @flow weak

import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import { reportActions } from "../../redux/actions/reportActions";
import { alertsActions } from "../../redux/actions/alertsActions";
import { siteActions } from "../../redux/actions/siteActions";
import MonthlyReport                   from './MonthlyReport';

const mapStateToProps = state => {
  return {
    loading: state.reportReducer.loading,
    error: state.reportReducer.error,
    reportData: state.reportReducer.reportData,
    MonthData: state.reportReducer.MonthData,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    siteList:state.siteReducer.siteList
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...reportActions,
        ...alertsActions,
        ...siteActions,
      },
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MonthlyReport);



// WEBPACK FOOTER //
// ./src/app/views/monthlyReport/index.js